import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { ButtonAnchor, ButtonLink } from '../ui/Button';
import { Reveal } from '../ui/Reveal';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../../utils/vehicles';
export function CtaFinal() {
  return <section className="border-t border-line/60 bg-ink py-16 md:py-24" data-id="element-263" data-mp="1kcwcazg3998v">
      <div className="mx-auto w-full max-w-7xl px-5 md:px-8" data-id="element-264" data-mp="1feba4uha0fhs">
        <Reveal data-id="element-265" data-mp="1tf5jpgg28mi1">
          <div className="relative overflow-hidden rounded-3xl border border-neon/45 bg-surface2/30 px-7 py-12 text-center backdrop-blur-md md:px-12 md:py-16" style={{
          boxShadow: '0 0 70px -28px rgba(31,123,255,0.9)'
        }} data-id="element-266" data-mp="1tem2k1y8i252">
            <div aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-0 h-px bg-neon/70" data-id="element-267" data-mp="1y6dvgj4v4jyd" />
            <h2 className="mx-auto max-w-3xl text-3xl font-black leading-[1.08] tracking-tight text-white md:text-[46px]" data-id="element-268" data-mp="2c6ye9fas2frv">
              Tu próximo auto te está esperando
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-mist md:text-lg" data-id="element-269" data-mp="n6n8pimq3kdm">
              Consultanos hoy y recibí asesoramiento personalizado para encontrar el
              vehículo ideal para vos.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-270" data-mp="w8cyyl4vcd9t">
              <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="lg" data-id="element-271" data-mp="11661n46yqp5c">
                <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-272" data-mp="1a5t7c26q6h47" />
                Hablar por WhatsApp
              </ButtonAnchor>
              <ButtonLink to="/catalogo" size="lg" data-id="element-273" data-mp="1ey2uxbkdb53b">
                Ver vehículos disponibles
              </ButtonLink>
            </div>
          </div>
        </Reveal>
      </div>
    </section>;
}